<template>
  <div>
    <div class="elasticResource-title">
      <div>{{ $t("alarms.elasticResource.elasticResource") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="['monitor:elasticResourceAli:add_alert_rule']"
          @click="addOrUpdateHandle"
          >{{ $t("alarms.elasticResource.addEipAlarm") }}</Button
        >
        <add-or-update-elastic-resource-ali-warning
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
        ></add-or-update-elastic-resource-ali-warning>
      </div>
    </div>
    <template>
      <Tabs size="small" v-model="currentTab" :animated="false">
        <TabPane
          :label="$t('alarms.elasticResource.elasticResourceList')"
          name="tabDisk"
        >
          <div class="elasticResource-top">
            <elastic-resource-search></elastic-resource-search>
          </div>
          <table-elastic-resource-ali></table-elastic-resource-ali>
        </TabPane>
        <TabPane :label="$t('alarms.common.alertRule')" name="tabAlertRule">
          <div class="elasticResource-top">
            <elastic-resource-ali-alert-rule-search></elastic-resource-ali-alert-rule-search>
          </div>
          <table-elastic-resource-ali-warning></table-elastic-resource-ali-warning>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
import ElasticResourceSearch from "../eip/ElasticResourceSearch";
import TableElasticResourceAli from "../eip/TableElasticResourceAli";
import ElasticResourceAliAlertRuleSearch from "../eip/ElasticResourceAliAlertRuleSearch";
import TableElasticResourceAliWarning from "../eip/TableElasticResourceAliWarning";
import AddOrUpdateElasticResourceAliWarning from "../eip/AddOrUpdateElasticResourceAliWarning";
const tableElasticResourceAliWarning = TableElasticResourceAliWarning;
export default {
  name: "ElasticResourceAli",
  components: {
    ElasticResourceSearch,
    TableElasticResourceAli,
    AddOrUpdateElasticResourceAliWarning,
    TableElasticResourceAliWarning,
    ElasticResourceAliAlertRuleSearch
  },
  data() {
    return {
      currentTab: "",
      addOrUpdateVisible: false
    };
  },
  methods: {
    // 添加报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    },
    changeCurrentTab: function(row, monitorIndex) {
      this.currentTab = "tabAlertRule";
      eventBus.$emit("volumeId", row.volumeAwsId);
      eventBus.$emit("monitorIndex", monitorIndex);
      eventBus.$emit("typeId", 1);
      // eventBus.$emit('stateId', 0);
      tableElasticResourceAliWarning.methods.showAll();
    }
  }
};
</script>

<style scoped>
.elasticResource-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.elasticResource-title > div:nth-child(1) {
  float: left;
}
.elasticResource-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.elasticResource-top {
  width: 100%;
  height: 32px;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/eip/ElasticResourceAli.vue